export const isGoogleAnalyticsConfigured = (integration = {}) => {
  return Boolean(integration?.ga_property)
}

export const isBigQueryConfigured = (integration = {}) => {
  return Boolean(integration?.bq_enabled && integration?.bq_project_id && integration?.bq_dataset_id)
}

export const resolveDirectorView = (integration = {}) => {
  if (isBigQueryConfigured(integration)) return 'bigquery'
  if (isGoogleAnalyticsConfigured(integration)) return 'googleAnalytics'
  return 'none'
}
